import React from "react";
import "./App.css";
import "./index.css";
import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Contact_Us from "./components/contact_us/Contact_Us";
import Terms_Conditions from "./components/terms-conditions/Terms_Conditions";
import Terms_Conditions_Drivers from "./components/terms-conditions-drivers/Terms_Conditions_Drivers";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import About_Us from "./components/about_us/About_Us";
import Services from "./components/services/Services";
import New_Contact_Us from "./components/contact_us/New_Contact_Us";
import Driver_Offers from "./components/driver_offers/Driver_Offers";
import Customer_Offers from "./components/customer_offers/Customer_Offers";


function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/old" element={<Contact_Us />} />
        <Route path="/contact-us" element={<New_Contact_Us />} />
        <Route path="/services" element={<Services/>}/>
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/terms-conditions-drivers" element={<Terms_Conditions_Drivers />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/driver-offers" element={<Driver_Offers />} />
        <Route path="/customer-offers" element={<Customer_Offers />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
